'use strict';

const util = require('./util');
const notifUtils = require('../utils/notificationUtils');

let isMainScriptLoaded = false;
let isPolyFillScriptLoaded = false;

/**
 * Load the core scripts into the document head
 */
function loadScripts() {
    const coreScripts = window.appData.resources.CORE_SCRIPT_URLS;
    if (coreScripts) {
        const polyfillScriptUrl = coreScripts.POLYFILL;
        const mainScriptUrl = coreScripts.MAIN;

        const polyfillScript = document.createElement('script');
        polyfillScript.src = polyfillScriptUrl;
        polyfillScript.type = 'module';

        const mainScript = document.createElement('script');
        mainScript.src = mainScriptUrl;
        mainScript.type = 'module';

        polyfillScript.addEventListener('load', () => {
            isPolyFillScriptLoaded = true;
        });

        mainScript.addEventListener('load', () => {
            isMainScriptLoaded = true;
        });

        document.head.appendChild(polyfillScript);
        document.head.appendChild(mainScript);
    }
}

/**
 * Check if the core script is loaded and send a notification if not
 * @returns {boolean} true if the core script is loaded, false otherwise
 */
function checkIfScriptLoaded() {
    const isScriptLoaded = isPolyFillScriptLoaded && isMainScriptLoaded;
    if (!isScriptLoaded) {
        notifUtils.send(window.appData.resources.ERROR_GLOBAL_MSG, 'error');
    }
    return isScriptLoaded;
}

/**
 * Handle the begin subscription
 */
function handleBeginSubscription() {
    $('.btn-club-subscription').on('click', function () {
        if (!checkIfScriptLoaded()) {
            return;
        }
        util.displayAppTunnel(util.CORE_PAGES.SUBSCRIPTION_TUNNEL, $(this).attr('data-subscription-origin'));
    });
}

/**
 * Handle the open app from url
 */
function handleOpenAppFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const openShadowDomModal = urlParams.get(util.QUERY_PARAMS.OPEN_CORE_MODAL);
    const subOrigin = urlParams.get(util.QUERY_PARAMS.SUB_ORIGIN);
    if (openShadowDomModal) {
        urlParams.delete(util.QUERY_PARAMS.OPEN_CORE_MODAL);
        urlParams.delete(util.QUERY_PARAMS.SUB_ORIGIN);
        const newQuery = urlParams.toString();
        const newUrl = newQuery ? window.location.pathname + '?' + newQuery : window.location.pathname;
        window.history.replaceState({}, document.title, newUrl);

        if (window.appData.resources.IS_HARD_LOGIN) {
            window.addEventListener(util.SCRIPT_LOADED_EVENT, function () {
                util.displayAppTunnel(openShadowDomModal, subOrigin);
            });
        } else {
            util.redirectToLogin(openShadowDomModal, subOrigin);
        }
    }
}

/**
 * Open the change payment method
 */
function openChangePaymentMethod() {
    $('.btn-club-change-payment').on('click', function () {
        if (!checkIfScriptLoaded()) {
            return;
        }
        const modalBody = document.querySelector('#sideModal .modal-body');
        modalBody.innerHTML = util.MODAL_BODY_CONTENT;
        util.openCoreApp(util.CORE_PAGES.PAYMENT_MODE_UPDATE, 'sideModalTitleText', null, true);
        util.showSideModal();
    });
}

/**
 * Display club anomaly popin
 */
function displayAnomaly() {
    const isHomepage = document.getElementById('home');
    if (isHomepage && window.appData.resources.ABO_ANOMALY) {
        const clubAnomaly = $('#clubAnomaly');
        $('#carouselHomepage').append(clubAnomaly);
        clubAnomaly.removeClass('d-none');
    }
}

/**
 * Listen for a custom event to open the app in a popin
 */
function openAppInPopinEvent() {
    window.addEventListener('core:open-popin', (event) => {
        const modalBody = document.querySelector('#sideModal .modal-body');
        modalBody.innerHTML = util.MODAL_BODY_CONTENT;

        const { page, data } = event.detail;
        util.openCoreApp(page, 'sideModalTitleText', data, true);
        util.showSideModal();
    });
}

/**
 * Handle the begin subscription for guest users by redirecting them to the login page
 */
function handleGuestSubscription() {
    $('.btn-club-subscription').on('click', function () {
        util.redirectToLogin(util.CORE_PAGES.SUBSCRIPTION_TUNNEL, $(this).attr('data-subscription-origin'));
    });
}

/**
 * Listen for a custom event from CORE to redirect to specific page
 */
function redirectSFRA() {
    window.addEventListener('core:redirect-to', function (event) {
        let routes = window.appData.resources.SFRA_URLS;
        let pageKey = event.detail.page;
        if (routes[pageKey]) {
            window.location = routes[pageKey];
        } else {
            notifUtils.send(window.appData.resources.ERROR_GLOBAL_MSG, 'error');
        }
    });
}

module.exports = {
    init: function () {
        if (window.appData.resources.IS_HARD_LOGIN) {
            loadScripts();
            handleBeginSubscription();
            openChangePaymentMethod();
            displayAnomaly();
            openAppInPopinEvent();
            redirectSFRA();
        } else {
            handleGuestSubscription();
        }
        handleOpenAppFromUrl();
    }
};
